import React from 'react';
import ProjectDetailHero from './sections/ProjectDetailHero';
import ProjectChallenge from './sections/ProjectChallenge';
import ProjectVision from './sections/ProjectVision';
import ProjectTechStack from './sections/ProjectTechStack';
import ProjectCTA from './sections/ProjectCTA';

const ProjectDetailPage = () => {
  return (
    <main className="min-h-screen bg-black">
      <ProjectDetailHero />
      <ProjectChallenge />
      <ProjectVision />
      <ProjectTechStack />
      <ProjectCTA />
    </main>
  );
};

export default ProjectDetailPage;